var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArcanum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(-2716 -22865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 50,
    height: 50,
    transform: "translate(2716 22865)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M16.517.3a1.661,1.661,0,0,0-.955-.3H10.786l-.078,0A1.566,1.566,0,0,0,9.9.3a1.689,1.689,0,0,0-.594.793L0,26.605l4.764,0a1.566,1.566,0,0,0,.815-.3,1.688,1.688,0,0,0,.594-.792l6.8-18.609,6.942,18.685a1.7,1.7,0,0,0,.578.708,1.661,1.661,0,0,0,.955.3l5.158,0L17.1,1.011A1.7,1.7,0,0,0,16.517.3Z",
    transform: "translate(2728.197 22877.197)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArcanum);
export default __webpack_public_path__ + "static/media/icon-arcanum.cac9166e0535da33fb624e3944d85440.svg";
export { ForwardRef as ReactComponent };